export const SIGN_TYPES = {
  main: 'Customer',
  initial: 'CustomerInitial',
  optional: 'customerOptionallnitials',
  customerOptionalSignature: 'customerOptionalSignature',
  customerSignature1Dependent: 'customerSignature1DependentcustomerAcknowledgementHolder'
};
